import React, { useState } from 'react';
import { MdArrowBack, MdClose } from 'react-icons/md';
import sendIcon from '../../../assets/send-icon.svg';
import './dialogs.css';

const EnquiryDialog = ({
  isOpen,
  onClose,
  onBack,
  project,
  breadcrumb,
  onSend,
}) => {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [sending, setSending] = useState(false);

  if (!isOpen) return null;

  const crumbs = breadcrumb ?? ['ENQUIRE', 'ARCHITECT', 'INNOVATION'];

  const handleSend = async () => {
    if (!email) return;
    setSending(true);
    await onSend?.({ email, message });
    setSending(false);
    setEmail('');
    setMessage('');
  };

  return (
    <div className="enq-overlay" onClick={onClose}>
      <div className="enq-panel" onClick={e => e.stopPropagation()}>
        <div className="enq-breadcrumb">
          {crumbs.map((crumb, i) => (
            <React.Fragment key={i}>
              {i > 0 && <span className="enq-breadcrumb-sep"> / </span>}
              <span className={i === crumbs.length - 1 ? 'enq-breadcrumb-active' : ''}>{crumb}</span>
            </React.Fragment>
          ))}
        </div>

        <div className="enq-header">
          <button className="ap-icon-btn" onClick={onBack ?? onClose} aria-label="Back">
            <MdArrowBack size={20} />
          </button>
          <h2 className="enq-title">{project?.name ?? 'Project Enquiry'}</h2>
          <button className="ap-icon-btn enq-close-btn" onClick={onClose} aria-label="Close">
            <MdClose size={20} />
          </button>
        </div>

        {project?.image && (
          <img
            src={project.image}
            alt={project.name}
            className="enq-project-image"
            onError={e => { e.target.style.display = 'none'; }}
          />
        )}

        <div className="enq-body">
          <label className="enq-label">Your email</label>
          <input
            type="email"
            className="enq-input"
            placeholder="you@company.com"
            value={email}
            onChange={e => setEmail(e.target.value)}
            autoFocus
          />

          <label className="enq-label">What are you interested in?</label>
          <textarea
            className="enq-textarea"
            placeholder="Tell the architect about your interest in this project"
            value={message}
            onChange={e => setMessage(e.target.value)}
            rows={4}
          />

          <div className="enq-actions">
            <button className="enq-cancel-btn" onClick={onClose}>Cancel</button>
            <button
              className="enq-send-btn"
              onClick={handleSend}
              disabled={!email || sending}
            >
              <img src={sendIcon} alt="" width={15} height={15} />
              {sending ? 'Sending...' : 'Send Enquiry'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EnquiryDialog;
